import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { buttonCss } from './button';

export const ButtonBorder = ({ children, icon, iconStyle, ...props }) => (
  <ButtonView {...props} icon={icon} iconStyle={iconStyle}>
    {children}
    <Icon styleProp={iconStyle}>{icon}</Icon>
  </ButtonView>
);

const Icon = styled.div`
  svg {
    ${Mixins.transition('fill')};
    fill: ${Colors.planoplan_blue};
  }
`;

const ButtonView = styled.button`
  ${buttonCss};
  background-color: ${Colors.azure};
  color: ${Colors.coal};
  border: 1px solid ${Colors.planoplan_blue};

  &:hover {
    background-color: ${Colors.azure};
    box-shadow: 0 0 0 1px ${Colors.electric_blue};
    border: 1px solid ${Colors.electric_blue};
    color: ${Colors.coal};

    svg {
      fill: ${Colors.electric_blue};
    }
  }
`;
